import React, {memo} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import PopUp from '@/components/popup/PopUp';
import * as APPDATA from '@/constants/pcConstAppData';
import {getMainPopUp} from '@/selectors/modalSelector';

function MainPopUp() {
  const dispatch = useDispatch();
  const {popUpVisible, popUpTitle, popUpText, popUpButton, popUpQuestion, popUpClose, popUpHideCloseButton} =
    useSelector(getMainPopUp);

  const handleOnClose = () => {
    dispatch(modalActions.hidePopUp());
    if (popUpClose !== undefined) {
      const e = {
        currentTarget: {
          id: APPDATA.CLOSE,
        },
      };
      popUpClose(e);
    }
  };

  return (
    <PopUp
      popUpButton={popUpButton}
      popUpHideCloseButton={popUpHideCloseButton}
      popUpQuestion={popUpQuestion}
      popUpText={popUpText}
      popUpTitle={popUpTitle}
      popUpVisible={popUpVisible}
      onClose={handleOnClose}
    />
  );
}

export default memo(MainPopUp);
